module.exports = __webpack_public_path__ + "static/media/mail.e8cbda22.svg";